import { render, staticRenderFns } from "./xbzd.vue?vue&type=template&id=c7c66dbe&scoped=true&"
import script from "./xbzd.vue?vue&type=script&lang=js&"
export * from "./xbzd.vue?vue&type=script&lang=js&"
import style0 from "./xbzd.vue?vue&type=style&index=0&id=c7c66dbe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c66dbe",
  null
  
)

export default component.exports